import { useState, useEffect } from 'react';
import { supabase } from '../supabase';

function DespesasFixas() {
  const [despesasFixas, setDespesasFixas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [abaAtiva, setAbaAtiva] = useState('fixa');
  const [nova, setNova] = useState({ nome: '', valor: '', categoria: 'fixa', total_parcelas: '', mes_inicio: new Date().getMonth() + 1, ano_inicio: new Date().getFullYear() });

  const formatarMoeda = (valor) => Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const meses = [
    { num: 1, label: 'Janeiro' }, { num: 2, label: 'Fevereiro' }, { num: 3, label: 'Março' },
    { num: 4, label: 'Abril' }, { num: 5, label: 'Maio' }, { num: 6, label: 'Junho' },
    { num: 7, label: 'Julho' }, { num: 8, label: 'Agosto' }, { num: 9, label: 'Setembro' },
    { num: 10, label: 'Outubro' }, { num: 11, label: 'Novembro' }, { num: 12, label: 'Dezembro' },
  ];

  useEffect(() => { buscarDespesasFixas(); }, []);

  const buscarDespesasFixas = async () => {
    setCarregando(true);
    const { data, error } = await supabase.from('despesas_fixas').select('*').eq('ativo', true).order('nome');
    if (!error) setDespesasFixas(data || []);
    setCarregando(false);
  };

  const adicionarDespesaFixa = async () => {
    if (!nova.nome || !nova.valor) return;
    const { error } = await supabase.from('despesas_fixas').insert({
      nome: nova.nome,
      valor: parseFloat(nova.valor),
      categoria: nova.categoria,
      total_parcelas: nova.categoria === 'parcela' ? parseInt(nova.total_parcelas) || 1 : null,
      parcelas_pagas: 0,
      mes_inicio: parseInt(nova.mes_inicio),
      ano_inicio: parseInt(nova.ano_inicio),
    });
    if (!error) {
      await propagarParaMeses(nova);
      buscarDespesasFixas();
      setNova({ nome: '', valor: '', categoria: 'fixa', total_parcelas: '', mes_inicio: new Date().getMonth() + 1, ano_inicio: new Date().getFullYear() });
      setMostrarForm(false);
    }
  };

  const propagarParaMeses = async (despesa) => {
    const mesInicio = parseInt(despesa.mes_inicio);
    const anoInicio = parseInt(despesa.ano_inicio);
    const inserções = [];

    if (despesa.categoria === 'fixa' || despesa.categoria === 'cartao') {
      // Insere do mês atual até dezembro de 2027
      let mes = mesInicio;
      let ano = anoInicio;
      while (ano < 2028) {
        inserções.push({
          nome: despesa.nome,
          valor: parseFloat(despesa.valor),
          categoria: despesa.categoria,
          mes: String(mes),
          ano: String(ano),
        });
        mes++;
        if (mes > 12) { mes = 1; ano++; }
      }
    } else if (despesa.categoria === 'parcela') {
      // Insere apenas para os meses das parcelas
      const total = parseInt(despesa.total_parcelas) || 1;
      let mes = mesInicio;
      let ano = anoInicio;
      for (let i = 1; i <= total; i++) {
        inserções.push({
          nome: despesa.nome,
          valor: parseFloat(despesa.valor),
          categoria: 'parcela',
          mes: String(mes),
          ano: String(ano),
          parcela_atual: i,
          total_parcelas: total,
        });
        mes++;
        if (mes > 12) { mes = 1; ano++; }
      }
    }

    if (inserções.length > 0) {
      await supabase.from('despesas').insert(inserções);
    }
  };

  const desativarDespesaFixa = async (id) => {
    await supabase.from('despesas_fixas').update({ ativo: false }).eq('id', id);
    buscarDespesasFixas();
  };

  const listaAtiva = despesasFixas.filter(d => d.categoria === abaAtiva);
  const totalFixas = despesasFixas.filter(d => d.categoria === 'fixa').reduce((acc, d) => acc + Number(d.valor), 0);
  const totalCartao = despesasFixas.filter(d => d.categoria === 'cartao').reduce((acc, d) => acc + Number(d.valor), 0);
  const totalParcelas = despesasFixas.filter(d => d.categoria === 'parcela').reduce((acc, d) => acc + Number(d.valor), 0);

  if (carregando) return <div className="flex items-center justify-center h-64"><p className="text-gray-400">Carregando...</p></div>;

  return (
    <div>
      <div className="mb-6 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-white">Central de Despesas</h2>
          <p className="text-gray-400 mt-1">Despesas fixas e parcelas recorrentes</p>
        </div>
        <button onClick={() => setMostrarForm(!mostrarForm)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
          + Nova Despesa
        </button>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
          <p className="text-gray-400 text-sm">Fixas Mensais</p>
          <p className="text-2xl font-bold text-white mt-1">{formatarMoeda(totalFixas)}</p>
          <p className="text-xs text-gray-500 mt-1">{despesasFixas.filter(d => d.categoria === 'fixa').length} despesas</p>
        </div>
        <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
          <p className="text-gray-400 text-sm">Cartão Mensal</p>
          <p className="text-2xl font-bold text-yellow-400 mt-1">{formatarMoeda(totalCartao)}</p>
          <p className="text-xs text-gray-500 mt-1">{despesasFixas.filter(d => d.categoria === 'cartao').length} despesas</p>
        </div>
        <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
          <p className="text-gray-400 text-sm">Parcelas Ativas</p>
          <p className="text-2xl font-bold text-orange-400 mt-1">{formatarMoeda(totalParcelas)}</p>
          <p className="text-xs text-gray-500 mt-1">{despesasFixas.filter(d => d.categoria === 'parcela').length} parcelas</p>
        </div>
      </div>

      {/* Formulário */}
      {mostrarForm && (
        <div className="bg-gray-900 rounded-xl border border-gray-800 p-6 mb-6">
          <h3 className="text-white font-semibold mb-4">Nova Despesa Recorrente</h3>
          <div className="grid grid-cols-3 gap-4">
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-400">Nome</label>
              <input type="text" value={nova.nome} placeholder="Ex: Salário Maria"
                onChange={(e) => setNova({ ...nova, nome: e.target.value })}
                className="bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 outline-none focus:border-blue-500" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-400">Valor (R$)</label>
              <input type="number" value={nova.valor} placeholder="0,00"
                onChange={(e) => setNova({ ...nova, valor: e.target.value })}
                className="bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 outline-none focus:border-blue-500" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-400">Categoria</label>
              <select value={nova.categoria} onChange={(e) => setNova({ ...nova, categoria: e.target.value })}
                className="bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 outline-none focus:border-blue-500">
                <option value="fixa">Fixa</option>
                <option value="cartao">Cartão</option>
                <option value="parcela">Parcela</option>
              </select>
            </div>
            {nova.categoria === 'parcela' && (
              <div className="flex flex-col gap-1">
                <label className="text-xs text-gray-400">Total de Parcelas</label>
                <input type="number" value={nova.total_parcelas} placeholder="12"
                  onChange={(e) => setNova({ ...nova, total_parcelas: e.target.value })}
                  className="bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 outline-none focus:border-blue-500" />
              </div>
            )}
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-400">Mês de Início</label>
              <select value={nova.mes_inicio} onChange={(e) => setNova({ ...nova, mes_inicio: e.target.value })}
                className="bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 outline-none focus:border-blue-500">
                {meses.map(m => <option key={m.num} value={m.num}>{m.label}</option>)}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-gray-400">Ano de Início</label>
              <select value={nova.ano_inicio} onChange={(e) => setNova({ ...nova, ano_inicio: e.target.value })}
                className="bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 outline-none focus:border-blue-500">
                {[2025, 2026, 2027].map(a => <option key={a} value={a}>{a}</option>)}
              </select>
            </div>
          </div>
          <div className="flex gap-3 mt-4">
            <button onClick={adicionarDespesaFixa} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700">Salvar e Propagar</button>
            <button onClick={() => setMostrarForm(false)} className="px-4 py-2 bg-gray-700 text-gray-300 rounded-lg text-sm font-medium hover:bg-gray-600">Cancelar</button>
          </div>
        </div>
      )}

      {/* Abas */}
      <div className="bg-gray-900 rounded-xl border border-gray-800">
        <div className="flex border-b border-gray-800">
          {[{ id: 'fixa', label: 'Fixas' }, { id: 'cartao', label: 'Cartão' }, { id: 'parcela', label: 'Parcelas' }].map((aba) => (
            <button key={aba.id} onClick={() => setAbaAtiva(aba.id)}
              className={`px-6 py-4 text-sm font-medium transition-colors ${abaAtiva === aba.id ? 'text-white border-b-2 border-blue-500' : 'text-gray-400 hover:text-white'}`}>
              {aba.label}
            </button>
          ))}
        </div>

        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-800">
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Nome</th>
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Valor</th>
              <th className="text-left p-4 text-gray-400 text-sm font-medium">Início</th>
              {abaAtiva === 'parcela' && <th className="text-left p-4 text-gray-400 text-sm font-medium">Parcelas</th>}
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {listaAtiva.length === 0 ? (
              <tr><td colSpan="5" className="p-8 text-center text-gray-500">Nenhuma despesa cadastrada.</td></tr>
            ) : (
              listaAtiva.map((d) => (
                <tr key={d.id} className="border-b border-gray-800 hover:bg-gray-800/50 transition-colors">
                  <td className="p-4 text-white">{d.nome}</td>
                  <td className="p-4 text-white">{formatarMoeda(d.valor)}</td>
                  <td className="p-4 text-gray-400">{meses.find(m => m.num === d.mes_inicio)?.label} {d.ano_inicio}</td>
                  {abaAtiva === 'parcela' && (
                    <td className="p-4 text-gray-400">{d.parcelas_pagas}/{d.total_parcelas}</td>
                  )}
                  <td className="p-4">
                    <button onClick={() => desativarDespesaFixa(d.id)}
                      className="text-gray-600 hover:text-red-400 transition-colors text-sm">✕</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DespesasFixas;